import styled from 'styled-components'
import { CheckmarkCircle } from 'src/components/icons/CheckMark'
import colors from 'src/constants/marketing-ds/colors'
import { spacing } from 'src/constants/marketing-ds/spacing'
import { mediaQuery } from 'src/constants/marketing-ds'

const FOOTNOTE_COPY = {
  en: ['Free trial', 'No contract required', 'Cancel anytime'],
  es: ['Prueba gratis', 'Sin contrato', 'Cancela cuando quieras'],
}

const FOOTNOTE_COPY_ESPN_UNLIMITED = {
  en: ['Free trial', 'Cancel anytime', 'ESPN Unlimited included'],
  es: ['Prueba gratis', 'Cancela cuando quieras', 'Incluye ESPN Unlimited'],
}

const HeroFootNote = ({ lang = 'en', showEspn = false, valuePropsCopy }) => {
  const valueProps = valuePropsCopy
    ? { [lang]: valuePropsCopy }
    : showEspn
      ? FOOTNOTE_COPY_ESPN_UNLIMITED
      : FOOTNOTE_COPY
  return (
    <FootnoteContainer>
      {valueProps[lang].map((copy, index) => (
        <FootnoteItem key={index}>
          <CheckmarkCircle />
          <span>{copy}</span>
        </FootnoteItem>
      ))}
    </FootnoteContainer>
  )
}

export default HeroFootNote

const FootnoteContainer = styled.span`
  display: flex;
  white-space: nowrap;
  flex-direction: column;
  gap: ${spacing.sm} ${spacing.md};

  ${mediaQuery.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
  }
  color: ${colors.white};
  svg {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
`

const FootnoteItem = styled.div`
  display: inline-flex;
  align-items: center;
`
